import { render, staticRenderFns } from "./PersonalNeedsBasedCalculator.vue?vue&type=template&id=626f761c&scoped=true&"
import script from "./PersonalNeedsBasedCalculator.vue?vue&type=script&lang=ts&"
export * from "./PersonalNeedsBasedCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalNeedsBasedCalculator.vue?vue&type=style&index=0&id=626f761c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f761c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VForm,VLayout,VRow})
